import { browserHistory } from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/configurations';

const ConfigurationService = {

  getAppConfiguration( accessToken ) {
    if( accessToken ) return axios.get( 'v1/configuration/info', {
      headers: { Authorization: `Bearer ${accessToken}` }
    } );
    return axios
      .get( 'v1/configuration/info' )
  },

  getComponentStatus( accessToken ) {
    if( accessToken ) return axios.get( 'v1/app-status', {
      headers: { Authorization: `Bearer ${accessToken}` }
    } );
    return axios
      .get( 'v1/app-status' )
  },

  getConfigurations( accessToken ) {
    if( accessToken ) return axios.get( baseEndpoint, {
      headers: { Authorization: `Bearer ${accessToken}` }
    } );
    return axios
      .get( baseEndpoint )
  },

  getConfiguration(id) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  getLogs( params ) {
    return axios
      .get( `${baseEndpoint}/api/logs`, { params } )
  },

  updateConfiguration( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}`, data )
  },

  updateIncms( id, data ) {
    return axios
      .get( `${baseEndpoint}/${id}/update`, data )
  },
};

export default ConfigurationService;



// WEBPACK FOOTER //
// ./services/ConfigurationService.js